<template>
  <vz-direction
    ref="direction"
    :location-guid="orderStore.orderForm.directions.dispatch.locationGuid"
    v-model:address="orderStore.orderForm.directions.dispatch.address"
    v-model:direction="orderStore.orderForm.directions.dispatch.direction"
    v-model:terminal-guid="orderStore.orderForm.directions.dispatch.terminalGuid"
    :location-search-options="locationSearchOptions"
    :cost="dispatchCost"
    :disabled="disabled"
    use-map
    terminal-purpose="from"
    title-card="Отправка"
    selector-title="Населенный пункт"
    class="vz-direction-card"
    @update:location-guid="onLocationChange"
    @update:address="onAddressChange"
  >
    <template #switch-append>
      <slot name="switch-append" />
    </template>
    <vz-direction-calendar
      :dates="dispatchDates"
      :disabled="calendarDisabled"
      @change-day="onChangeDispatchDay"
    />
    <vz-direction-calendar-time
      v-if="dispatchDate && isDispatchAddressPoint"
      :date="dispatchDate"
      :disabled="calendarDisabled"
      :has-waiting="!hideWaiting"
      :confirmable-time="confirmableTime"
      @select-time="orderStore.updateTimeTable"
    />
    <vz-direction-calendar-terminal-time
      v-else
      :date="dispatchDate"
      :disabled="calendarDisabled"
      @select-time="orderStore.updateTimeTable"
    />
  </vz-direction>
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import {Location, OrderDirectionAddress, TimetableDate} from '~/types/types';
import {formatDate} from '~/common/date';
import VzDirection from '~/components/personal/order/direction/vz-direction.vue';
import VzDirectionCalendar from '~/components/personal/order/direction/calendar/vz-direction-calendar.vue';
import VzDirectionCalendarTime from '~/components/personal/order/direction/calendar/vz-direction-calendar-time.vue';
import VzDirectionCalendarTerminalTime from '~/components/personal/order/direction/calendar/vz-direction-calendar-terminal-time.vue';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  hideWaiting: {
    type: Boolean,
    default: false
  }
})

const { $showToast } = useNuxtApp()
const orderStore = useOrderStore()

const direction = ref()

const calendarDisabled = computed(() => {
  return props.disabled || (Number(orderStore.dispatchLocation?.fake) === 1)
})

const dispatchDates = computed((): TimetableDate[] => {
  return orderStore.timetable?.dispatch || []
})

const dispatchDate = computed((): TimetableDate | null => {
  return orderStore.timetable?.dispatch?.find(d => d.isDefault) as TimetableDate
})

const isDispatchAddressPoint = computed(() => {
  return orderStore.orderForm.directions.dispatch.direction === 'address'
})

const confirmableTime = computed(() => {
  return orderStore.orderType !== 'multi' || !!orderStore.multiOrder.selectedRequestId
})

const dispatchCost = computed(() => {
  return orderStore.orderPrice?.address?.dispatch?.price?.total
    ? ` (${orderStore.orderPrice?.address?.dispatch?.price?.total} ${orderStore.orderPriceCurrency.currency})`
    : ''
})

const locationSearchOptions = computed(() => {
  return { purpose: 'order', destination: orderStore.orderForm.directions.destination.locationGuid }
})

function onChangeDispatchDay(date: TimetableDate) {
  orderStore.orderForm.directions.dispatch.calendar.date = formatDate(date.date, 'YYYY-MM-DD')
}

async function onLocationChange(guid: string, location?: Location) {
  orderStore.orderForm.directions.dispatch.locationGuid = guid

  if (orderStore.orderForm.additionalServices.returning.locationGuid && guid) {
    orderStore.orderForm.additionalServices.returning.locationGuid = guid
  }

  if (location) {
    orderStore.dispatchLocation = location
    orderStore.orderForm.directions.dispatch.country = location.country || orderStore.orderForm.directions.dispatch.country
    // Смена страны участника
    const customer = orderStore.orderForm.customer.dispatch
    customer.country = orderStore.orderForm.directions.dispatch.country || customer.country
  }
}

function onAddressChange(value: string, obj: OrderDirectionAddress) {
  if (obj) {
    orderStore.orderForm.directions.dispatch.region = obj.region

    if (obj?.offerWaitingTime && obj.offerWaitingTime > 30 && obj.offerWaitingTime > orderStore.orderForm.directions.dispatch.waitingTime) {
      const time = orderStore.waitingTimeList.list[obj.offerWaitingTime]
      $showToast({
        title: 'Время ожидания',
        text: `По данному адресу замечены частые случаи простоя машины. Рекомендуем заранее указать предполагаемое время: ${time}`,
        variant: 'warning',
        autocloseDelay: 20000,
        cancelButtonText: 'Не нужно',
        buttonText: 'Подтвердить',
        buttonCB: () => {
          orderStore.orderForm.directions.dispatch.waitingTime = obj.offerWaitingTime || 30
        }
      })
    }
  }
}
</script>

<style lang="scss">

</style>
